<div class="cont-contenido-modal">
      <Input label="Mes" bind:value={mesFactura} />
      <Input label="Año" bind:value={yearFactura} />
      <!-- <InputExcel bind:value={aux} /> -->
      <!-- aux:{aux} -->
      <Combo bind:arr={arrEmpresasDB} bind:value={empresaSel} texto="Empresa" />

      <div class="cont-agregar-nvo-det-factura col-12 flex">
            <div class="col-8 sin-padding-left">
                  <Combo bind:arr={arrProductosDB} bind:value={productoSel} texto="Producto" />
            </div>
            <div class="col-4">
                  <BotonX
                        clases="mt-3 col-12"
                        on:click={() => agregarFila()}
                        texto="Agregar"
                        disabled={productoSel == null}
                        icono="plus"
                  />
            </div>
      </div>
      {arrDetsFactura}
      <TablaExcelDetProds bind:arrDatos={arrDetsFactura} />
</div>

<script>
      import BotonX from "./../basics/BotonX.svelte";
      import Input from "../basics/Input.svelte";
      import TablaExcelDetProds from "./../basics/TablaExcelDetProds.svelte";
      import { BOTONERA_MODAL_STORE, proceed, back } from "../../stores/modal-store";
      import { onMount } from "svelte";
      import Combo from "../basics/Combo.svelte";
      import { GATEWAY } from "../../stores/gateway-store";
      import InputExcel from "../basics/InputExcel.svelte";
      export let modalOpen;
      export let readyModal;
      let aux = "tu vieja";
      let mesFactura;
      let yearFactura;
      let empresaSel;
      let productoSel;
      let arrEmpresasDB = [];
      let arrProductosDB = [];
      let arrDetsFactura = [];
      onMount(() => {
            mesFactura = new Date().getMonth();
            yearFactura = new Date().getFullYear();

            // Asignar las funciones a los botones cuando el modal se monte
            BOTONERA_MODAL_STORE.set({
                  proceed: enviarFactura, // Asigna la función para el botón "Proceed"
                  back: back, // Asigna la función para el botón "Back"
            });

            async function MountAsync() {
                  arrEmpresasDB = await findEmpresas();
                  arrProductosDB = await findProductos();

                  // TO-DO: QUITAR:
                  productoSel = arrProductosDB[0];
                  agregarFila();
            }
            MountAsync();
      });
      $: if (empresaSel) {
            readyModal = true;
            console.log("Empresa seleccionada:", empresaSel);
            // Aquí puedes realizar cualquier lógica relacionada con `empresaSel`
      }

      async function enviarFactura() {
            const url = $GATEWAY.url + "factura/";
            const data = {
                  mesFactura: mesFactura,
                  yearFactura: yearFactura,
                  fkEmpresa: 1,
            };

            try {
                  const response = await fetch(url, {
                        method: "POST",
                        headers: {
                              accept: "*/*",
                              "Content-Type": "application/json",
                        },
                        body: JSON.stringify(data),
                  });

                  // Manejo de la respuesta
                  if (response.ok) {
                        const jsonResponse = await response.json();
                        console.log("Factura enviada:", jsonResponse);
                        modalOpen = false;
                  } else {
                        console.error("Error al enviar la factura:", response.statusText);
                  }
            } catch (error) {
                  console.error("Error en la solicitud:", error);
            }
      }
      export async function findEmpresas() {
            let arr = [];
            console.log("FIND EMPRESAS");
            try {
                  const url = $GATEWAY.url + "empresa/";
                  const response = await fetch(url);
                  if (!response.ok) {
                        throw new Error("Error al obtener empresas: " + response.statusText);
                  }
                  arr = await response.json();
            } catch (error) {
                  console.error("Error en fetchEmpresas:", error);
            }

            return arr;
      }
      export async function findProductos() {
            let arr = [];
            console.log("FIND PRODUCTOS");
            try {
                  const url = $GATEWAY.url + "producto/";
                  const response = await fetch(url);
                  if (!response.ok) {
                        throw new Error("Error al obtener productos: " + response.statusText);
                  }
                  arr = await response.json();
            } catch (error) {
                  console.error("Error en fetchProductos:", error);
            }

            return arr;
      }
      function agregarFila() {
            console.log("Agregando Fila () -> arrDetsFactura: " + arrDetsFactura.length);

            if (productoSel != null) {
                  let nombreProductoSel = productoSel.nombre;
                  let precioProductoSel = productoSel.precioSugerido;
                  console.log("PRODUCTO SEL: " + nombreProductoSel);
                  console.log("PRODUCTO PRECIO SEL: " + precioProductoSel);
                  // arrProductosX.push({ nombre: "Producto X", precioUnitario: 1520, cantidad: 3 });
                  arrDetsFactura = [
                        ...arrDetsFactura,
                        {
                              nombre: nombreProductoSel,
                              precioUnitario: precioProductoSel,
                              cantidad: 1,
                        },
                  ];

                  setTimeout(function () {
                        productoSel = null;
                  }, 250);
            }
      }
</script>

<style>
</style>
